export default {
      id: "bill-medical-usage",
      viewBox: "0 0 26 33",
      url: __webpack_public_path__ + "sprite.svg#bill-medical",
      toString: function () {
        return this.url;
      }
    }